import { LAYOUTS, TEACHER_ROLES } from "shared/constants";
import { myStudentsConversationsFragment } from "conversations/routes/fragments";
import type { AppRouteRecordRaw } from "shared/types";
import { getRememberedClassroomTab } from "./lastActiveTab";
import { MENTOR_CLASS_ROUTE_NAMES } from "./routeNames";

const routes: AppRouteRecordRaw[] = [
  {
    path: "/my-students/:mentorClass",
    name: MENTOR_CLASS_ROUTE_NAMES.MAIN,
    component: () => import("classroom/pages/MentorClassPage.vue"),
    meta: {
      title: "Mijn leerlingen",
      roleRequired: TEACHER_ROLES,
      layout: LAYOUTS.MAIN_NO_WRAPPER,
      hideTitle: true,
    },
    redirect: (to) => ({
      name:
        getRememberedClassroomTab("mentor") ??
        MENTOR_CLASS_ROUTE_NAMES.STUDENTS,
      params: to.params,
    }),
    children: [
      {
        path: "students",
        name: MENTOR_CLASS_ROUTE_NAMES.STUDENTS,
        component: () => import("classroom/pages/MentorClassStudentsPage.vue"),
        meta: {
          title: "Mijn leerlingen",
          roleRequired: TEACHER_ROLES,
          layout: LAYOUTS.MAIN_NO_WRAPPER,
        },
      },
      {
        path: "student-ratings",
        name: MENTOR_CLASS_ROUTE_NAMES.STUDENT_RATINGS,
        component: () =>
          import("classroom/pages/MentorClassStudentMeetingPage.vue"),
        meta: {
          title: "Leerlingbespreking",
          roleRequired: TEACHER_ROLES,
          layout: LAYOUTS.MAIN_NO_WRAPPER,
        },
      },
      {
        path: "advisory-ratings",
        name: MENTOR_CLASS_ROUTE_NAMES.ADVISORY_RATINGS,
        component: () =>
          import("classroom/pages/MentorClassAdvisoryMeetingPage.vue"),
        meta: {
          title: "Adviesbespreking",
          roleRequired: TEACHER_ROLES,
          layout: LAYOUTS.MAIN_NO_WRAPPER,
        },
      },
      {
        path: "group-ratings",
        name: MENTOR_CLASS_ROUTE_NAMES.GROUP_RATINGS,
        component: () =>
          import("classroom/pages/MentorClassGroupMeetingPage.vue"),
        meta: {
          title: "Groepsbespreking",
          roleRequired: TEACHER_ROLES,
          layout: LAYOUTS.MAIN_NO_WRAPPER,
        },
      },
      {
        path: "portfolio",
        name: MENTOR_CLASS_ROUTE_NAMES.PORTFOLIO,
        component: () => import("classroom/pages/MentorClassPortfolioPage.vue"),
        meta: {
          title: "Portfolio",
          roleRequired: TEACHER_ROLES,
          layout: LAYOUTS.MAIN_NO_WRAPPER,
        },
      },
      {
        path: "tasks",
        name: MENTOR_CLASS_ROUTE_NAMES.TASKS,
        component: () => import("classroom/pages/MentorClassTasksPage.vue"),
        meta: {
          title: "Taken",
          roleRequired: TEACHER_ROLES,
          layout: LAYOUTS.MAIN_NO_WRAPPER,
        },
      },
      {
        path: "learning-goals",
        name: MENTOR_CLASS_ROUTE_NAMES.LEARNING_GOALS,
        component: () =>
          import("classroom/pages/MentorClassLearningGoalsPage.vue"),
        meta: {
          title: "Leerdoelen",
          roleRequired: TEACHER_ROLES,
          layout: LAYOUTS.MAIN_NO_WRAPPER,
        },
      },
      {
        path: "actionplans",
        name: MENTOR_CLASS_ROUTE_NAMES.ACTIONPLANS,
        component: () =>
          import("classroom/pages/MentorClassActionplanPage.vue"),
        meta: {
          title: "Actieplannen",
          roleRequired: TEACHER_ROLES,
          layout: LAYOUTS.MAIN_NO_WRAPPER,
        },
      },
      {
        path: "conversations",
        name: MENTOR_CLASS_ROUTE_NAMES.CONVERSATIONS,
        component: () =>
          import("classroom/pages/MentorClassConversationsPage.vue"),
        meta: {
          title: "Gesprekken",
          roleRequired: TEACHER_ROLES,
          layout: LAYOUTS.MAIN_NO_WRAPPER,
        },
      },
      ...myStudentsConversationsFragment,
    ],
  },
];

export default routes;
